import React from "react";
import DACIPagination from "components/DACIPagination";
import { Pagination, Stack, Box, Grid, useTheme, useMediaQuery } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import PropTypes from "prop-types";
import usePermission from "hooks/usePermission";
import { useMaterialUIController } from "context";
import colors from "assets/theme/base/colors";

export default function RoleList({
  handleRoleCreate,
  handleRoleList,
  handleRoleEdit,
  handleRoleDelete,
  pageIndexAndPageSize,
  entriesStart,
  entriesEnd,
  totalData,
  totalPages,
  currentPage,
  handlePageChange,
  handleOpenNew,
}) {

  let { white, text } = colors;

  const iconColor = text.main; // #7b809a - mismo color que el texto de las tablas
  white = white.main;

  // Obtener el estado del tema (modo oscuro/claro)
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  // Verificar permisos
  const canCreate = usePermission("Crear", "Roles");
  const canEdit = usePermission("Editar", "Roles");
  const canDelete = usePermission("Eliminar", "Roles");

  // Hook para detectar breakpoints responsivos
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md')); // < 960px
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm')); // < 600px

  return (
    <>
      {/* Contenedor responsivo para todos los botones de acción */}
      <Box sx={{
        mt: isMobile ? 2 : -6,
        mb: 3,
        px: { xs: 1, sm: 2, md: 3 },
        width: '100%'
      }}>
        {/* Grid responsivo para botones de acción */}
        <Grid container spacing={1} justifyContent={isMobile ? "center" : "flex-end"} alignItems="center" sx={{ gap: 0 }}>
          {canCreate && (
            <Grid item  >
              <MDButton onClick={handleRoleCreate} variant="gradient" color="info">
                Crear
              </MDButton>
            </Grid>
          )}
        </Grid>
      </Box>
      <DataTable
        table={{
          columns: [
            { Header: "Nombre", accessor: "name", align: "center" },
            { Header: "acciones", accessor: "action", width: "12%", align: "center" },
          ],
          rows: handleRoleList
            ? handleRoleList.map((role) => ({
              id: (
                <MDTypography
                  component="a"
                  href="#"
                  variant="caption"
                  color="text"
                  fontWeight="medium"
                >
                  {role.id}
                </MDTypography>
              ),
              name: role.name,
              software_id: (
                <MDTypography
                  component="a"
                  href="#"
                  variant="caption"
                  color="text"
                  fontWeight="medium"
                >
                  {role.software_id}
                </MDTypography>
              ),
              action: (
                <>
                  {role.name !== "Superadmin" && (
                    <>
                      {canDelete && (
                        <a
                          data-id={role.id}
                          data-name={role.name}
                          data-softwareid={role.software_id}
                          onClick={handleRoleDelete}
                          style={{ marginLeft: "8px", cursor: "pointer" }}
                        >
                          <DeleteForeverOutlinedIcon
                            titleAccess="Eliminar"
                            style={{
                              fontSize: "200px",
                              width: "24px",
                              height: "24px",
                              color: darkMode ? white : iconColor,
                            }}
                          />
                        </a>
                      )}
                      {canEdit && (
                        <a
                          data-id={role.id}
                          data-name={role.name}
                          data-softwareid={role.software_id}
                          data-description={role.description}
                          onClick={handleRoleEdit}
                          style={{ marginLeft: "8px", cursor: "pointer" }}
                        >
                          <EditOutlinedIcon
                            titleAccess="Editar"
                            style={{
                              fontSize: "200px",
                              width: "24px",
                              height: "24px",
                              color: darkMode ? white : iconColor,
                            }}
                          />
                        </a>
                      )}
                    </>
                  )}
                </>
              ),
            }))
            : [],
        }}
        canSearch={false}
        isSorted={false}
        entriesPerPage={false}
        showTotalEntries={false}
        pageIndexAndPageSize={pageIndexAndPageSize}
        pagination={{ variant: "gradient", color: "info" }} // Estilo de paginación
      />

      {!handleRoleList ? (
        <MDBox style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          <MDTypography
            style={{ left: "20px", fontSize: "20px" }}
            variant="button"
            color="secondary"
            fontWeight="regular"
          >
            No hay datos
          </MDTypography>
        </MDBox>
      ) : (
        <>
          {/* Mostrar la paginación */}
          <MDBox style={{ marginLeft: "20px" }} mb={{ xs: 3, sm: 0 }}>
            <MDTypography
              style={{ left: "20px" }}
              variant="button"
              fontWeight="regular"
            >
              Mostrando {entriesStart} hasta {entriesEnd} de {totalData} resultados en total
            </MDTypography>
          </MDBox>
          <Stack style={{ marginLeft: "20px", marginBottom: "10px" }} spacing={2}>
            <DACIPagination
              count={totalPages}
              page={currentPage}
              onChange={handlePageChange}
            />
          </Stack>{" "}
        </>
      )}
    </>
  );
}

RoleList.propTypes = {
  handleRoleCreate: PropTypes.func,
  handleRoleList: PropTypes.array,
  handleRoleDelete: PropTypes.func,
  pageIndexAndPageSize: PropTypes.func,
  entriesStart: PropTypes.number,
  entriesEnd: PropTypes.number,
  totalData: PropTypes.number,
  totalPages: PropTypes.number,
  currentPage: PropTypes.number,
  handlePageChange: PropTypes.func,
  handleRoleEdit: PropTypes.func,
};
